import React from 'react';
import styles from './FormField.module.scss';

interface ToggleGroupProps {
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
  /**
   * 'segmented' renders a full-width, bordered segmented control with a check
   * on the active option (the account org-type design — options share the row
   * equally and wrap instead of overflowing). 'default' keeps the compact
   * inline pills used elsewhere.
   */
  variant?: 'default' | 'segmented';
  className?: string;
  style?: React.CSSProperties;
}

export function ToggleGroup({ options, value, onChange, variant = 'default', className, style }: ToggleGroupProps) {
  const segmented = variant === 'segmented';
  return (
    <div className={`${segmented ? styles.seg : styles.toggleGroup} ${className || ''}`} style={style}>
      {options.map((opt) => {
        const active = value === opt.value;
        const btnClass = segmented
          ? `${styles.segOpt} ${active ? styles.segOptSel : ''}`
          : `${styles.toggleGroupBtn} ${active ? styles.toggleGroupActive : ''}`;
        return (
          <button key={opt.value} type="button" className={btnClass} onClick={() => onChange(opt.value)}>
            {segmented && (
              <svg
                className={styles.segCheck}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
